// local
import {
  SET_IS_MODULE_LOADED,
  SecCallbackActions,
  SetInputValidated,
  SET_INPUT_SEC_EXTRA_SHORT,
  SET_FORM_LOADING_SEC_EXTRA_SHORT,
  SetFormLoading,
  SET_FORM_SUCCESS_SEC_EXTRA_SHORT,
  SetFormSuccess,
  SetGeneralErrorMessage,
  SET_CHECKBOX_SEC_EXTRA_SHORT,
  SetCheckboxValidated,
  SET_GENERAL_ERROR_SEC_EXTRA_SHORT,
  RESET_FORM_SEC_EXTRA_SHORT,
  SetCampaign,
  SET_CAMPAIGN_SEC_EXTRA_SHORT,
} from './actions';

export type SecExtraShortData = {
  isModuleLoaded: boolean;
  isLoading: boolean,
  isSuccess: boolean,
  generalError: {
    message?: string,
  },
  recaptcha: {
    value: string,
    error: string,
  },
  name: {
    value: string,
    error: string,
  },
  email: {
    value: string,
    error: string,
  },
  agreeToTermsAndConditions: {
    value: {[key: string]: boolean},
    error: string,
  },
  campaign: {
    name: string;
    source: string;
    medium: string;
  }
};

export const initialState: SecExtraShortData = {
  isModuleLoaded: false,
  isLoading: false,
  isSuccess: false,
  generalError: {
    message: '',
  },
  recaptcha: {
    value: '',
    error: '',
  },
  name: {
    value: '',
    error: '',
  },
  email: {
    value: '',
    error: '',
  },
  agreeToTermsAndConditions: {
    value: {
      agreed: true,
    },
    error: '',
  },
  campaign: {
    name: '',
    source: '',
    medium: '',
  },
};

const secCallbackReducer = (
  state: SecExtraShortData = initialState,
  action: SecCallbackActions,
): SecExtraShortData => {
  switch (action.type) {
    case SET_IS_MODULE_LOADED:
      return {
        ...state,
        isModuleLoaded: true,
      };
    case SET_INPUT_SEC_EXTRA_SHORT:
      return {
        ...state,
        ...(action as SetInputValidated).payload,
      };
    case SET_CHECKBOX_SEC_EXTRA_SHORT:
      console.log('SET_CHECKBOX_SEC_EXTRA_SHORT action:', action, state); // eslint-disable-line
      return {
        ...state,
        agreeToTermsAndConditions: {
          ...(state.agreeToTermsAndConditions || {}),
          value: {
            agreed: Boolean((action as SetCheckboxValidated).payload.isChecked),
          },
        },
      };
    case SET_CAMPAIGN_SEC_EXTRA_SHORT: {
      return {
        ...state,
        campaign: (action as SetCampaign).payload,
      };
    }
    case SET_FORM_LOADING_SEC_EXTRA_SHORT: {
      return {
        ...state,
        isLoading: (action as SetFormLoading).payload.isLoading,
      };
    }
    case SET_FORM_SUCCESS_SEC_EXTRA_SHORT: {
      return {
        ...state,
        isSuccess: (action as SetFormSuccess).payload.isSuccess,
      };
    }
    case SET_GENERAL_ERROR_SEC_EXTRA_SHORT: {
      return {
        ...state,
        generalError: {
          message: (action as SetGeneralErrorMessage).payload,
        },
      };
    }
    case RESET_FORM_SEC_EXTRA_SHORT: {
      return initialState;
    }
    default:
      return state;
  }
};

export default secCallbackReducer;
